import React from 'react';
export function StickyHeader() {
  return <div className="sticky top-0 z-40 flex min-h-[36px] w-full items-center justify-center bg-cobalt px-4 py-2 text-center" data-id="element-179" data-mp="2zat6uoerv308">
      <p className="text-[11px] font-medium leading-snug text-white sm:text-xs" data-id="element-180" data-mp="1ir7ukifwfhu4">
        <span className="sm:hidden" data-id="element-181" data-mp="1ip55q1qhfuqz">🌎 Available Worldwide · Instant Download</span>
        <span className="hidden sm:inline" data-id="element-182" data-mp="1dsxze7u6ch8i">
          🌎 Available Worldwide · Instant Download · Built for High School Chemistry Teachers
        </span>
      </p>
    </div>;
}